import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { useProStudioCtxSelector } from '../../xstate/app.xstate';
import { buildSolutionVersionsRoute } from './channel-route';

/**
 * A solution's Versions page, or `null` when it leads nowhere — without going
 * there. Same split as `useChannelRoute`, for the same reason.
 */
export const useSolutionVersionsRoute = () => {
  const projectId = useProStudioCtxSelector((ctx) => ctx.project?.id);

  return useCallback(
    (solutionId: string) => buildSolutionVersionsRoute(projectId, solutionId),
    [projectId]
  );
};

/**
 * Navigates to a solution's Versions page, where the solution id is the same
 * one `useGoToChannel` resolves for a channel. Does nothing without a route.
 *
 * Stable identity (`useCallback`): the table's memoized `columns` depend on it.
 */
export const useGoToSolutionVersions = () => {
  const navigate = useNavigate();
  const versionsRoute = useSolutionVersionsRoute();

  return useCallback(
    (solutionId: string) => {
      const route = versionsRoute(solutionId);
      if (route) navigate(route);
    },
    [navigate, versionsRoute]
  );
};
